import { gql } from '@apollo/client';

// Get Campaign Kiosks (Placements) for Details Tab with Pagination
export const GET_CAMPAIGN_KIOSKS = gql`
  query GetCampaignKiosks(
    $campaignId: Int!
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    campaignKiosks(
      first: $first
      last: $last
      after: $after
      before: $before
      where: { campaignId: { eq: $campaignId } }
      order: { createdDate: DESC }
    ) {
      totalCount
      edges {
        node {
          id
          contractPrice
          evergreenPrice
          boosted
          bumpable
          digitalSeconds
          reservationStart
          reservationEnd
          installedImageUrl
          kioskAdPlacement {
            id
            typeName
          }
          kiosk {
            importKioskId
            kioskType {
              id
              typeName
            }
            isDigital
            digitalTotalTime
            digitalReservedTime
            monthlyImpressions
            kioskLocationId
            kioskLocation {
              typeName
            }
            venueId
            venue {
              id
              venueName
              address1
              address2
              state
              city
              zip
              venueRank
            }
          }
          kioskId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

// Get Campaign Billing Info for Details Tab
export const GET_CAMPAIGN_BILLING_INFO = gql`
  query GetCampaignBillingInfo($campaignId: Int!) {
    campaignBillingInfo(where: { campaignId: { eq: $campaignId } }) {
      id
      campaignId
      paymentCount
      productionFee
      subTotal
      discount
      total
      paymentFrequency
      paymentFrequencyNavigation {
        typeName
      }
      downPaymentAmount
      monthlyPaymentAmount
      billingStartDate
      splitPayments
    }
  }
`;

// Get Campaign Team/Users
export const GET_CAMPAIGN_USERS = gql`
  query GetCampaignUsers($campaignId: Int!) {
    campaignUsers(campaignId: $campaignId) {
      campaignRoleType
      user {
        id
        firstName
        lastName
        email
        phone
      }
    }
  }
`;

export const GET_PAST_DUE_INVOICES= gql`
query GetPastDueInvoicesByCampaign($campaignId: Int!) {
  pastDueInvoicesByCampaign(campaignId: $campaignId) {
    id
    invoiceNumber
    invoiceDate
    campaignId
    dueDate
    invoiceTotal
    invoiceStatusId
    invoiceNotes
    paidDate
    voided
    createdDate
    lastUpdated
    campaign {
      id
      name
      statusId
      signedDate
    }
    invoiceStatus {
      id
      statusName
      statusGroup
      displayOrder
    }
    invoiceLines {
      id
      lineNumber
      quantity
      amount
      lineTypeId
      description
      voided
      internalNotes
    }
  }
}
`

export const GET_PAYOFF_INVOICES= gql`
query GetPendingInvoices($campaignId: Int!) {
  pendingInvoices(campaignId: $campaignId) {
    id
    invoiceNumber
    invoiceDate
    campaignId
    dueDate
    invoiceTotal
    invoiceStatusId
    invoiceNotes
    paidDate
    voided
    createdDate
    lastUpdated
    campaign {
      id
      name
      statusId
      signedDate
    }
    invoiceStatus {
      id
      statusName
      statusGroup
      displayOrder
    }
    invoiceLines {
      id
      lineNumber
      quantity
      amount
      lineTypeId
      description
      voided
      internalNotes
    }
  }
}
`

export const GET_BILL_PAY_INVOICE_BY_NUMBER = gql`
query GetBillPayInvoiceByNumber($campaignId: Int!, $invoiceNumber: String!) {
  billPayInvoiceByNumber(campaignId: $campaignId, invoiceNumber: $invoiceNumber) {
    id
    invoiceNumber
    invoiceDate
    campaignId
    dueDate
    invoiceTotal
    invoiceStatusId
    invoiceNotes
    paidDate
    voided
    createdDate
    lastUpdated
    campaign {
      id
      name
      statusId
      signedDate
    }
    invoiceStatus {
      id
      statusName
      statusGroup
      displayOrder
    }
    invoiceLines {
      id
      lineNumber
      quantity
      amount
      lineTypeId
      description
      voided
      internalNotes
    }
  }
}
`